module.exports = __webpack_public_path__ + "img/crossover_driving.6512efd3.svg";